import { Container, Image } from 'react-bootstrap';
import styled from 'styled-components';
import { Link } from "react-router-dom";

export const StyledHeader = styled.header`
  top: 0;
  left: 0;
  width: 100%;
  min-height: 90px;
  max-height: 15vh;
  background: #F9F6EE;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Ensures it stays on top */
`;

export const LeftHeaderContainer = styled(Container)`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Logo = styled(Image)`
  height: 5rem;
  width: auto; /* Maintain aspect ratio */
`;

export const Title = styled.h1`
  font-size: 30px;
  color: black;
  margin: 0;
`;

export const RightNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: #4c4b4d;
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  border: 2px solid #edebed;
  padding: 5px;
  border-radius: 8px;

  &:hover {
    background: #e4dfe6;
  }
`;